export const TOTAL_ROUNDS = 5;
export const CARDS_PER_PLAYER = 13;
export const NUM_PLAYERS = 4;
export const MAX_BID = 8;
